export const lang = {
  MINDER_INSPECTION: 'MINDER  INSPECTION',
  header: {
    Home: 'Home',
    Service: 'Service & Solution',
    Guide: 'Guide',
    About_us: 'About us',
    Language: 'Language',
    Log_in: 'Log in',
    Product_Quality_Control: 'Product Quality Control Service',
    Vendor_Assessment_Service: 'Vendor Assessment Service',
    Get_started: 'Get started',
    Reference_Cases: 'Reference Cases',
    zh: 'Chinese',
    footer_address: '6th  Floor Yuhang Shanghui Mansion Hangzhou China',
  },
  home: {
    Md_Object: '曼德服务对EN',
    Why_choose_us: 'Why choose us',
    Quality_Control_Team: 'Quality Control Team',
    Quality_Control_text:
      'We have more than 7000 quality engineers which comes from international  institutions and third party certificate group. With professional inspection capability, the experienced   team will be able to provide excellent quality control services.',
    Response_in_High: 'Response in High Efficiency',
    Response_in_Text:
      'You are able to access to reach the inspection progress such as detailed images and data anytime. Plus, all the data are instantly updated and  the reports will be released within 24H. Our service team are monitoring and communicating with all parties to ensure a impartial inspection result.',
    Amazing_Price: 'Amazing Price',
    Amazing_Text:
      'Travel to the factory site may cost you more on flights and accommodations. With our service, there’s no extra cost to worry about. Enjoy special discounts for our package deal. ',
    Solutions_Services: 'Solutions & Services',
    Product_Quality_Control: 'Product Quality Control',
    Product_Quality_Control_text:
      'With our experienced quality control team, we’re able to serve customers in a wide range of industries.  Your ’ll get logical and digital inspection reports covering all the details you care most.',
    Learn_more: 'Learn more',
    Vendor_Assessment: 'Vendor Assessment',
    Vendor_Assessment_text:
      'Stable and trustworthy business partners are quite fundamental to your company. We visit your vendors and do on-site assessment.  Key data and images will be collected for your reference over different aspects.',
  },
  Register: {
    Mobile_phone: 'Mobile phone',
    phone_Number_text: 'Please input your E-mail',
    verification_code: 'Please input the verification code',
    Get_Verified: 'Get Verified',
    Please_password: 'Please set your new  password',
    Register: 'Register',
    E_mail: 'E-mail',
    Please_ailbox: 'Please enter your mailbox',
  },
  AboutUs: {
    Md_Object: '曼德服务对象-EN',
    What_can_we_bring: 'What can we bring to you',
    What_can_text:
      'What can we bring to you Minder Inspection(V . Minder TM) is a third-party inspection platform which combines Internet tech with quality control services. We provide quality control services such as product inspection, vendor auditing, Loading supervision etc. which help customers optimizing quality system.  Our smart monitoring system brings highly efficient quality tracking experiences. With advanced information technology and experienced quality engineers, we are now able to serve global customers in all industries and create higher values. ',
    Company_Profile: 'Company Profile',
    Contact_us: 'Contact us',
    Contact_Info: 'Contact Info',
    OUR_VISION: 'OUR VISION',
  },
  qaQcService: {
    Minder: '',
    pro_ser: '',
    pro_good: '',
    service_title: 'Quality Control Services',
    Quality_Control_ServicesOne: ' ',
    Quality_Control_ServicesTow: '',
    Quality_Control_ServicesThree:
      'We know what you care most and we present every quality detail to you',
    Flexible_response_mechanism: 'Flexible response mechanism',
    Flexible_response_mechanism_text:
      'Communicating anytime with our engineers during inspection,',
    Flexible_response_mechanism_text_one:
      'we’re ready for any instant requirements.',
    Save_time: 'Save time,Save money',
    order_text: 'No worry about extra travel cost, we cover them all',
    order_text_one: '',
    mdservice: '',
    anxin: '',
    The_Best_Quality_Control_One: 'The Best Quality Control Team',
    The_Best_Quality_Control_text_One:
      '7000+  professional quality engineers right at your service',
    The_Best_Quality_Control_Tow: '',
    The_Best_Quality_Control_text_Tow: '',
    Intelligent_Order_System: 'Intelligent Order System',
    Intelligent_Order_System_text:
      'It only takes you 5 minutes to create an order on line.',
    Immediate_Processing_Management: 'Immediate Processing Management',
    Immediate_Processing_Management_text:
      'Every inspection order is running smoothly and efficiently based on the elaborate processing system',
    Product_Quality_Control_Services: 'Product Quality Control Services',
    Final_Inspection: 'Final Inspection',
    Final_Inspection_text:
      "Final Inspection is a most effective way that confirms the whole shipment's quality level. It normally requires the production to be 100% complete and at least 80% of goods to be packed into cartons. Quality engineers will do the random sampling and inspect strictly according to the AQL standards.",
    During_Production_Inspection: 'During Production Inspection',
    During_Production_Inspection_text:
      'During Production Inspection is performed when 30%- 50% goods are finished and packed. This inspection validates the initial production process has been maintained and that goods being produced continue to meet quality requirements. In the case of new raw materials, new operators, production lines or specification changes, this service can assess if requirements are being met during production.',
    Loading_Supervision: 'Loading Supervision',
    Loading_Supervision_text:
      'Loading Supervision provides witness to the loading process, to make sure the correct quantity and good condition cartons are loaded into good condition containers.\n',
    Groceries: 'Groceries',
    Groceries_text:
      'Tool, Toy, Furniture, Hardware, Decoration, Personal care, Outdoor equipment etc. ',
    Fabric_Textiles: 'Fabric & Textiles',
    Fabric_Textiles_text:
      'fabric, textile and raw material, home furnishing etc.',
    Garment_Bags: 'Garment & Bags',
    Garment_Bags_text: 'Garment, Accessory, Bag, Luggage, Shoe etc.',
    Electronics_Electrical_Equipment: 'Electronics & Electrical Equipment',
    Electronics_Electrical_text:
      'Home electrical equipment, Electronics, Lights, Electronic accessory etc.',
    Product_Inspection_Service: 'Product Inspection Service',
    Get_specific_quote: 'Get specific quote',
    Loading_Supervision_Service: 'Loading Supervision Service',
    Best_Service_With_Amazing_Price: 'Best Service With Amazing Price',
    start_from_s: '',
    start_from: 'start from',
    money: '$125',
  },
  Login: {
    Service_Center: 'Service Center',
    Log_in: 'Log in',
    Register: 'Register',
    Sign_up: 'Sign up',
    Forget_password: 'Forget password',
    Home_page: 'Home page',
    Please_Number_mail: 'Please input your E-mail',
    Please_input_your_password: 'Please input your password',
    err_text: 'The account name or password is incorrect.',
  },
  menuList: {
    My_Minder: 'My Minder',
    Instant_Order: 'Instant Order',
    Product_Inspection: 'Product Inspection',
    Product_Inspection_ML:'Fabric Inspection',
    Factory_Assessment: 'Factory Assessment',
    Loading_Supervision: 'Loading Supervision',
    User_Center: 'User Center',
    General_Information: 'General Information',
    My_Wallet: 'My Wallet',

    My_Package: 'My Package',
    My_Coupons: 'My Coupons',
    My_Ordre: 'My Order',
    Order_List: 'Order List',
    Uncompleted: 'Uncompleted',
    Completed: 'Completed',
    Canceled: 'Canceled',
    Drafts: 'Drafts',
    My_Reports: 'My Reports',
    Inspection_Reports: 'Inspection Reports',
    My_Review: 'My Review',
    Wait_for_Review: 'Wait for Review',
    Reviewed: 'Reviewed',
    current_location: 'Current Location',
  },
  menuGoodsSpace: {
    Product_Inspection_text:
      'Minder provide efficient and impartial inpection services including Mid-Term & Final inspection,  Fabric inspection etc.  You will enjoy our quick response simply by putting basic information.   Let s get started ',
    Language: 'Language',
    Chinese: 'Chinese',
    English: 'English',
    Change_Password: 'Change Password',
    Log_out: 'Log out',
    Inspection_type: 'Inspection type',
    Mid_Term_Inspection: 'Mid Term Inspection',
    Final_Inspection: 'Final Inspection',
    Fabric_Inspection: 'Fabric Inspection',
    Batch_Inspection: 'Batch Inspection',
    //==========验货表单============
    history_orders: 'History Orders',
    continue_order: 'Continue',
    Vendor_Information: 'Vendor Information',
    Factory_Cn: 'Please fill in the factory name',
    Vendor_Name: 'Vendor Name',
    Region: 'Region',
    Please_fill_in_the_region: 'Please fill in the region',
    Vendor_Address: 'Vendor Address',
    Vendor_Address_text: 'Please fill in the vendor address',
    Contact_Name: 'Contact Name',
    Please_contact_name: 'Please fill in the contact name',
    Telephone: 'Telephone',
    Please_Telephone_number: 'Please fill in the Telephone number',
    Mobile: 'Mobile',
    Please_mobile_number: 'Please fill in the mobile number',
    E_mail: 'E-mail',
    Please_E_mail_Add: 'Please fill in the E-mail Add.',
    Company_Profile: 'Company Profile',
    Company_Name: 'Company Name',
    Please_company_Name: 'Please fill in the company name',
    Company_Address: 'Company Address',
    Please_company_Address: 'Please fill in the company Address',
    Product_Details: 'Product Details',
    Product_Name: 'Product Name',
    Please_product_name: 'Please fill in the product name',
    Item_Number_Style: 'Item Number/Style',
    Please_product_style: 'Please fill in the product style',
    Order_Number: 'Order Number',
    Please_order_number: 'Please fill in the order number',
    Quantity: 'Quantity',
    Unit: 'Unit',
    Units: 'Unit',
    pcs: 'pcs',
    pair: 'pair',
    // individual: '个',
    yard: 'yard',
    set: 'set',
    ctn: 'ctn',
    Other: 'Other',
    Inspection_standard: 'Inspection standard*',
    Inspection_Level: 'Inspection Level*',
    Inspection_levels: 'Inspection Level',
    Inspection_data: 'Inspection data',
    AQL: 'AQL',
    Critical: 'Critical ',
    Major: 'Major',
    Minor: 'Minor',
    Inspection_Date: 'Inspection Date',
    Select_date: 'Select date',
    Please_select_date:
      'Please select estimated date if there is no confirmed inspection date.  Our QC will contact the factory for further confirmation.',
    inspection_files: 'inspection files',
    upload: 'upload',
    upload_text:
      'Please upload files as PDF,PPT,WORD,EXCEL,JPG,JPEG.  Single  File should be under 20M. ',
    Special_Attention: 'Special Attention',
    Please_special_attention: 'Please fill in special attention',
    Generating_orders: ' Create the order',
    Add_to_draft: 'Add to draft',
    product: 'Item',
    //面料
    Color: 'Color',
    Please_fill_in_color: 'Please fill in color',
    Dimension: 'Dimension',
    please_fill_in_dimension: 'please fill in dimension',
    Weight: 'Weight',
    please_fill_in_weight: 'please fill in weight',
    Material: 'Material',
    please_fill_in_material: 'please fill in material',
    point_system: '(4 point system)',
    Max_penalty_points_text: ' Max penalty points per 100 square yard',
    Max_penalty_points: 'Max 1 point defect per 100 square yard',
    It_will_be_judged:
      'It will be judged as fail, despite of the penalty points, if the defective rolls are more than 10% of the total quantity.',
    Confirm_the_Order: 'Confirm the Order',
    Order_details: 'Order details',

    With_Minder_Loading_Supervision:
      'With Minder’s Loading Supervision,  your order will be shipped out at just the right time ',
    Container: 'Container',
    Container_Information: 'Container Information',
    Loading_Quantity: 'Loading Quantity',
    Arrival_time: 'Arrival time',
    Please_fill_in_Arrival_time: 'Please fill in Arrival time',
    Loading_can_only:
      'Loading can only be supervised after the container arrived.   There’ll be extra cost (1 MD) if the container arrived late (8hours) or the  loading process lasts more than 8 hours.  ',
    Factory_Evaluation: 'Factory Evaluation',
    Minder_provides_professional:
      'Minder provides professional Factory Evaluation service which gives you a specific picture of your future partner .',
    Please_select_estimated:
      'Please select estimated date if there is no confirmed inspection date.  Our QC will contact the factory for further confirmation  .',
  },
  UserCenter: {
    General_Information: 'General Information',
    Security_Level: 'Security Level',
    Company_Profile: 'Company Profile',
    E_mail: 'E mail',
    Unverified_Email: 'Unverified Email',
    Fix_Now: 'Fix Now',
    Please_set_your_password: 'Please set your password',
    update: 'update',
    Password: 'password',
    Please_enter_your_mailbox: 'Please enter your mailbox',
    Please_enter_your_mailbox_address: 'Please enter your mailbox address',
    Please_enter_the_verification_code: 'Please enter the verification code',
    Get_the_authentication_code: 'Verification',
    cancel: 'cancel',
    Immediate_binding: 'Immediate binding',
    Modify_login_password: 'Modify login password',
    Please_enter_the_original_password: 'Please enter the original password',
    Check_text:
      ' Please input Number The password should be a combination of capital letters, lowercase letters as well as numbers. Keep them between 8 to 30 characters.',
    Check_New_password: 'Please input a new password',
    Check_password_tow: 'Please input the new password again ',
    confirm_update: 'Confirm',
    /*============安全等级=================*/
    Your_Security_Level: 'Your Security Level',
    Log_in_password: 'Log in password',
    pay_password: 'Pay Password',
    Get_your_password_more_secure: 'Get your password more secure',
    Settings: 'Settings',
    Verify_your_mobile_number: 'Verify your mobile number',
    Verify: 'Verify',
    Rebind_mailbox: 'Rebind mailbox',
    Company_files: 'Company files',
    Improve_account_level: 'Improve account security and trust level',
    Modify_Payment_Password: 'Modify Payment Password',
    Please_enter_digit_payment_password:
      'Please enter a 6-digit payment password',
    If_payment_password: 'if the payment password is not set, it can be empty.',
    please_payment_password: 'Please enter a 6-digit payment password',
    Clear: '取消',
    Mobile_phone_number_verification: 'Mobile phone number verification',
    Please_phone_number: 'Please enter your cell phone number.',
    Mailbox_Verification: 'Mailbox Verification',
    /*============企业资料=================*/
    Company_Profile_t: 'Company Profile',
    Photo: 'Photo',
    Company_Name: 'Company Name',
    please_company_name: 'please input company name',
    Region: 'Region',
    Please_region: 'Please select the region',
    Sepecific_Add: 'Sepecific Add',
    Please_ADD: 'Please input the ADD',
    Contact_Name: 'Contact Name',
    Please_contact_name: 'Please input the contact name',
    Mobile_Number: 'Mobile Number',
    Telephone_Number: 'Telephone Number',
    Please_Tel_Number: 'Please input the Tel. Number',
    Licence_registration: 'Licence registration',
    Please_License_Number: 'Please fill in Licence Number',
    Licence: 'Licence',
    update_imaeg_text: '1、files should be within 2M. (JPG/PNG)',
    Company_text:
      '2、Minder·s verify system is in sync with Government.  All fake licences will be detected and rejected.',
    Submit: 'Submit',
    Company_text_tow:
      '2. Please dont upload fake receipt, otherwise the payment will not be admitted',
    /*============我的钱包=================*/
    My_Wallet: 'My Account',
    Balance: 'Balance',
    Recharge: 'Recharge',
    My_Coupons: 'My Coupons',
    Account_Details: 'Account Details',
    Date: 'Date',
    Details: 'Details',
    Account_Change: 'Account Change',
    Account_Balance: 'Account Balance',
    Income: 'Income',
    Expenditure: 'Expenditure',
    //我的套餐
    My_Package: 'My Package',
    Package_List: 'Package List',
    Purchase_Record: 'Purchase Record',
    Consume_Record: 'Consume Record',
    Item_Nr: 'Item Nr',
    Package_Nr: 'Package Nr',
    Package: 'Package',
    Original_rem: 'Original(¥)',
    Original_ub: 'Original($)',
    Package_Price_rem: 'Package Price (￥)',
    Package_Price_ub: 'Package Price($)',
    Total_MD: 'Total MD',
    Operate: 'Operate',
    Check_out_now: 'Check out now',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    Package_Order_Nr: 'Package Order Nr',
    Service_Date: 'Service Date',
    Service_Order_Nr: 'Service Order Nr',
    Purchase_Date: 'Purchase Date',
    Quantity: 'Quantity',
    Sum: 'Total Amount',
    Status: 'Status',
    Voucher: 'Voucher',
    //我的代金劵
    // My_Coupons: '我的代金劵',
    Available: 'Available',
    Used: 'Used',
    Expired: 'Expired',
    Click_to_use: 'Click to use',
    Get_when_registed: 'Get when registed',
    Validity_Time: 'Validity Time',
    /*============充值=================*/
    Select_Currency: 'Select Currency',
    Charge_RMB: 'Charge RMB',
    Charge_USD: 'Charge USD',
    Select_Amount: 'Select Amount',
    Payment_Method: 'Payment Method',
    Alipay: 'Alipay',
    Wechat_Pay: 'Wechat Pay',
    Total_Amount: 'Total Amount',
    Unit: '$',
    Ather_Amounts: 'For other amounts, the amount should be more than 100 yuan',
    _Submit: 'Submit',
  },
  No_data: 'No data available for the time being',
  // 我的订单
  orderAll: {
    // 全部订单
    Order_List: 'Order List',
    Order_Number: 'Order Nr',
    Order_Type: 'Order Type',
    Service_Date: 'Service Date',
    Factory_sel:'Factory',
    PO_Number:'PO Number',
    Product_Name:'Product Name',
    Item_Number:'Item Number',
    Order_status: 'Order Status',
    Serach: 'Serach',
    Vendor_name: 'Vendor',
    Order_date: 'Order date',
    Service_fee: 'Service fee',
    Total_MD: 'Total MD',
    Operate: 'Operate',
    Serial_Number: 'Nr',
    Uncompleted: 'Uncompleted',
    Completed: 'Completed',
    Canceled: 'Canceled',
    Drafts: 'Drafts',
    search: 'Search',
    Select_the_order_type: 'Select the order type',
    Select_the_date: 'Select the date',
    Select_the_order_status: 'Select the order status',
    Pay: 'Pay',
    View_Report: 'View Report',
    down_Report: 'Down Report',

    Edit: 'Edit',
    Cancel: 'Cancel',
    Recover: 'Recover',
    Delete: 'Delete',
    View: 'View',
    Review: 'Review',
    To_be_confirmed: 'To be confirmed',
    To_be_paid: 'To be paid',
    To_be_assigned: 'To be assigned',
    Order_release: 'Order release',
    To_be_served: 'To be served',
    Under_inspecting: 'Under inspecting',
    Under_auditing: 'Under auditing',
    To_be_translated: 'To be translated',
    To_be_reviewed: 'To be reviewed',
    Finished: 'Finished',
    Draft: 'Draft',
  },
  //我的报告
  Reports: {
    Inspection_Reports: 'Inspection Reports',
    System_order_Nr: 'System order Nr',
    Order_Nr: 'PO Number',
    sys_nr:'System Order Nr.',
    
    Service_Date: 'Service Date',
    Report_Date: 'Report Date',
    Start_from: 'Start from',
    End: 'End',
    // Inspection_Reports: '验货报告',
    Nr: 'Nr',
    Report_Nr: 'Report Nr',
    Customer: 'Customer',
    Category: 'Category',
    Factory: 'Factory',
    Service_data: 'Service data',
    Total_MD: 'Total MD',
    // Order_Nr: '订单号',
    Report: 'Report',
  },
  // 我的评价
  Review: {
    Wait_for_Review: 'Wait for Review',
    Reviewed: 'Reviewed',
    Quality_Engineer: 'Quality Engineer',
    Order_Type: 'Order Type',
    Nr: 'Nr',
    Time_keeping: 'Time keeping',
    professional_ethics: 'professional ethics',
    Skill: 'Skill',
    Communication: 'Communication',
    Communications: 'Communication',
    Order_Nr: 'Order Nr',
    Comment: 'Comment',
    Operate: 'Operate',
    Save: 'Save',
    Inspector_Rate: 'Inspector Rate',
    Service_Rate: 'Service Rate',
    Inspector_ID: 'Inspector ID:',
    Customer_Service_ID: 'Customer Service ID:',
    Back: 'Back',
  },
  // 支付方式页面
  payType: {
    Balance_on_Account: 'Balance on Account',
    Pay_in_RMB: 'Pay in RMB',
    Pay_in_USD: 'Pay in USD',
    Pay_in_Package: 'Pay in Package',
    Package: 'Package',
    System_Order_Nr: 'System Order Nr.',
    Order_Type: 'Order Type',
    Report_Type: 'Report Type',
    Amount: 'Amount',
    PayPal_Surcharge: 'PayPal Surcharge',
    Payment_currency: 'Payment currency',
    Coupon: 'Coupon',
    Not_Available: 'Not Available',
    Valid_Till: 'Valid Till',
    Final_Payment: 'Final Payment',
    Renminbi: 'Pay in RMB',
    U_S_dollar: 'Pay in USD',
    Payment: 'Payment',
    Optional_package: 'Optional package',
    Surplus: 'Surplus',
    MD: ' MD',
    Bank_Transfer: 'Bank Transfer',
    Photo_Bank_required: 'Photo of the Bank receipt is required',
    Submit: 'Submit',
    Wechat_Pay: 'Wechat Pay',
    with_no_extra_cost: 'with no extra cost',
    Alipay: 'Alipay',
    PayPal: 'PayPal',
    Extra_text: 'There will be Extra 4.5% cost',
    Pay_with_Account_Balance: 'Pay_with_Account_Balance',
  },
  // 支付弹框
  payModule: {
    Please_finish_payment_page: ' Please finish the payment on the new page.',
    pay_module_text:
      'Please do not close this window and click the button below after the payment is done.',
    Done: 'Done',
    Need_help: 'Need help',
    Sorry_payment: 'Sorry, payment failed.',
    Please_service_contact:
      'Please try again later or contact customer service:',
  },
  //我的报告详情
  ReportsDetail: {
    GENERAL_INFORMATION: 'GENERAL INFORMATION', //基本资料
    Client_Name: 'Client Name:',
    Factory_Name: 'Factory Name:',
    Factory_Address: 'Factory Address:',
    Product_Name: 'Product Name:',
    PO_Number: 'P.O.Number:',
    Item_Number: 'Item Number:',
    Order_Quantity: 'Order Quantity:',
    Actual_Shipment_Quantity: 'Actual Shipment Quantity:',
    Inspector_s: 'Inspector(s):',
    Factory_Representative: 'Factory Representative:',
    Inspection_Started_at: 'Inspection Started at:',
    Inspection_Completed_at: 'Inspection Completed at:',
    Product: 'Product',
    Cleargov: 'Anti-bribery and Sampling seal',
    Factorycard: 'Factory Gate',
    Remarkphoto: 'Remark',
    BULK_SUMMARY: 'BULK SUMMARY', //大货情况
    Packed: 'Packed:',
    Unpacked: 'Unpacked:',
    Semi_finished: 'Semi-finished:',
    Sambox: 'Sampling Cartons：',
    Samproduct: 'Sampling products：',
    Remarks: 'Remarks:',
    P_O_Number: 'P.O.Number',
    Product_name: 'Product Name',
    Completed_quantity: 'Completed quantity',
    packed: 'Packed',
    unpacked: 'Unpacked',
    Total_Carton: 'Total Carton',
    Semi_finished_Quantity: 'Semi-finished Quantity',
    ActualShipmentQuantity: 'Actual Shipment Quantity',
    Batch_1: 'Item 1',
    Batch_2: 'Item 2',
    Batch_3: 'Item 3',
    Batch_4: 'Item 4',
    Batch_5: 'Item 5',
    Batch_6: 'Item 6',
    Batch_7: 'Item 7',
    Batch_8: 'Item 8',
    Batch_9: 'Item 9',
    PACKING_INFORMATION: 'PACKING INFORMATION', //包装描述
    Carton_Seal: 'Carton Seal:',
    Main_Mark: 'Main Mark:',
    Side_Mark: 'Side Mark:',
    Carton_barcode: 'Carton barcode:',
    Carton_Size: 'Carton Size:',
    Carton_Weight: 'Carton Weight:',
    Inner_Packing: 'Inner Packing:',
    Corrugated_Layer: 'Corrugated Layer:',
    Inner_Box: 'Inner Box:',
    Inner_Packing_Details: 'Inner Packing Details:',
    Inner_Packing_Size: 'Inner Packing Size:',
    Accessory_Manual_Polybag: 'Accessory/Manual/Polybag:',
    CartonSize: 'Carton Size',
    CartonWeight: 'Carton Weight',
    Packing_Detail_For_Shipping_Carton: 'Packing Detail For Shipping Carton',
    Unit_Packing_Detail: 'Unit Packing Detail',
    Product_Packing_Size: 'Product Packing Size',
    WORKMANSHIP: 'WORKMANSHIP', //产品工艺
    Defect_Description: 'Defect Description:',
    Defect_Quantity: 'Defect Quantity:',
    Defects: 'Defects:',
    Remark: 'Remark:',
    Defect: 'Defect:',
    Critical: 'Critical',
    Major: 'Major',
    Minor: 'Minor',
    DEFECTS_DISPOSAL: 'DEFECTS DISPOSAL', //瑕疵品处理
    Defective_Product_Area: 'Defective Product Area:',
    Vendor_Representative_Confirmed: 'Vendor Representative Confirmed:',
    QC_Confirmed: 'QC Confirmed:',
    Untreated: 'Unable to dispose',
    Cancel: 'Cancel',
    Rework: 'Rework',
    Nr: 'Nr.',
    DefectDescription: 'Defect Description',
    Data_records: 'Data records',
    DefectQuantity: 'Defect Quantity',
    rework: 'Disposed on site',
    replace: 'Claimed to dispose',
    cancel: 'Cancel',
    Product_Details: 'Product Details', //产品细节
    Front: 'Front:',
    Side: 'Side:',
    Back: 'Back:',
    Inside: 'Inside',
    Details: 'Details:',
    Product_Measurements: 'Product Measurements',
    Contrastphoto: 'Confirmation Sample Match：',
    Main_Product_Size: 'Main Product Size',
    productName: 'Product Name',
    Length: 'L',
    Width: 'W',
    Height: 'H',
    Weight: 'Weight',
    Accessory: 'Accessory',
    Size: 'Size(A*B*C)',
    TEST: 'DATA MEASUREMENT / FIELD TEST', //现场测试/数据记录
    Test_photo: 'Photo',
    Field_Test: 'Field Test:',
    Test_Requirement: 'Test Requirement:',
    Quantity: 'Quantity:',
    Conclude: 'Conclude:',
    Brief_Report: 'Brief Report', //总概
    Overall_Conclusion: 'Overall Conclusion',
    PASS: 'PASS',
    PENDING: 'PENDING',
    FAIL: 'FAIL',
    Brief_Findings: 'Brief Findings',
    Bulk_Summary: 'A.Bulk Summary',
    Packing_Information: 'B.Packing Information',
    Workmanship: 'C.Workmanship',
    ProductDetails: 'D.ProductDetails',
    Data_Measurement_Field_Test: 'E.Data Measurement Field Test',
    Defects_Disposal: 'F.Defects Disposal',
    Pass: 'Pass',
    Pending: 'Pending',
    Fail: 'Fail',
    Description: 'Description',
    Customer_Requirements: 'Customer Requirements',
    Reply: 'Reply',
    Return: 'Return',
    Descriptions: 'Description',
    Unfinished: 'Unfinished',
  },
  //监装报告详情
  LoadingReport: {
    GENERAL_INFORMATION: 'GENERAL INFORMATION',
    Client_Name: ' Client Name',
    Loadig_Address: ' Loadig Address',
    PO_Number: 'P.O. Number',
    Item_Number: 'Item Number',
    Product_Name: 'Product Name',
    Inspector_s: 'Inspector(s)',
    Inspection_Started_at: 'Inspection Started at',
    Inspection_Completed_at: 'Inspection Completed at',
    Container_Type: 'Container Type',
    Container_Condition: 'Container Condition',
    Container_No: 'Container No.',
    Seal_Number: 'Seal Number',
    Loading_Quantity: 'Loading Quantity',
    Gates: 'Gates',
    Packed: 'Packed',
    Unpacked: 'Unpacked',
    Semi_finished: 'Semi-finished',
    Completed: 'Completed ',
    Uncompleted: 'Uncompleted',
    Quantity_pcs: 'Quantity (pcs)',
    Cartons_CTN: 'Cartons (CTN)',
    Quantity_pcs1: 'Quantity (pcs)',
    Cartons_CTN1: 'Cartons (CTN)',
    Packing_Information: 'Packing Information',
    Carton_Seal: 'Carton Seal',
    Front_Mark: ' Front Mark',
    Side_Mark: 'Side Mark',
    Carton_barcode: 'Carton barcode',
    Carton_Size: 'Carton Size',
    Carton_Weight_Gross: 'Carton Weight (Gross)',
    Inner_Packing: ' Inner Packing',
    Corrugated_Layer: 'Corrugated Layer',
    Inner_box: 'Inner box',
    Packing_Details_Single_unit: ' Packing Details (Single unit)',
    Others_Accessory_Manual_Polybag: 'Others (Accessory/Manual/Polybag etc.)',
    Product_Details: 'Product Details',
    Front_View: 'Front View',
    Side_View: 'Side View',
    Back_View: 'Back View',
    Inside_View: 'Inside View',
    Details: 'Details',
    Product_Color: '（Product Color ）',
    Truck_And_Container: 'Truck And Container',
    Truck_Front: 'Truck Front',
    Licence: 'Licence',
    Container_Side: 'Container Side',
    Container_Inside_Check: 'Container Inside Check',
    Container_No_Inside: 'Container No. (Inside)',
    Container_No_Outside: 'Container No. (Outside)',
    Truck_Badge_Back: ' Truck Badge(Back)',
    Loading_Process: 'Loading Process',
    Order_Quantity_pcs: 'Order Quantity (pcs)',
    Order_Cartons_CTN: 'Order Cartons (CTN)',
    Actual_Loaded_Quantit_pcs: 'Actual Loaded Quantity（pcs）',
    Actual_Loaded_Cartons_CTN: 'Actual Loaded Cartons(CTN)',
    Container_Sealing_Photo: 'Container Sealing Photo',
    Loading_quarter: 'Loading（1/4）',
    Loading_half: 'Loading（1/2）',
    Loading_three_quarter: 'Loading（3/4）',
    Loading_Finished: 'Loading Finished',
    Right_Door_Closed: 'Right Door Closed',
    Both_Door_Closed: 'Both Door Closed',
    Seal_Container: ' Seal Container',
    Seal: 'Seal',
    Seal_No: 'Seal No.',
    Brief_Report: 'Brief Report',
    Overall_Conclusion: 'Overall Conclusion',
    PASS: 'PASS',
    PENDING: 'PENDING',
    FAIL: 'FAIL',
    Brief_Findings: 'Brief Findings ',
    Loading_Quantity1: 'A.Loading Quantity',
    Packing_Information1: 'B.Packing Information',
    Product_Details1: 'C.Product Details',
    Truck_And_Container1: 'D.Truck And Container',
    Loading_And_Stuffing: 'E.Loading And Stuffing',
    Container_Sealing: 'F.Container Sealing',
    Conform: 'Conform',
    Pending: 'Pending',
    Not_Conform: 'Not Conform',
    Customer_Requirements: 'Customer Requirements',
    Loading_Finished_Photo: 'Loading Finished Photo',
    Remark: 'Remark',
  },
  //面料报告详情
  FabricReport: {
    GENERAL_INFORMATION: 'GENERAL INFORMATION',
    Client_Name: 'Client Name',
    Factory_Name: 'Factory Name',
    Factory_Address: 'Factory Address',
    PO_Number: 'P.O Number',
    Product_Name: 'Product Name',
    Style_Model_Number: 'Style/Model Number',
    Order_Quantity: 'Order Quantity',
    Documents: 'Documents',
    Inspectors: 'Inspector(s)',
    Factory_Representative: 'Factory Representative',
    Inspection_Started_at: ' Inspection Started at',
    Inspection_Completed_at: ' Inspection Completed at',

    BULK_SUMMARY: 'BULK SUMMARY',
    Packed: 'Packed',
    Unpacked: 'Unpacked',
    Packed1: 'Packed',
    Unpacked1: 'Unpacked',
    Packing_List: 'Packing List',
    Color: 'Color',
    Ticket_Length: 'Ticket Length',
    Actual_Length: 'Actual Length',
    Sample_Length: 'Sample Length（yard）',
    Roll_Qty: 'Roll Qty',

    PACKING_INFORMATION: 'PACKING INFORMATION',
    Roll_Packed_Details: 'Roll Packed Details',
    Shipping_Mark_Lable: 'Shipping Mark & Lable',
    Inner_Packing_Details: 'Inner Packing Details',
    Collateral_Others: 'Collateral / Others',
    Confirmed_packing_information:
      'Confirmed packing information provided for check',
    yes: 'Yes',
    no: 'No',

    WORKMANSHIP: 'WORKMANSHIP',
    Dye_Lot: 'Dye Lot',
    Roll_Number: 'Roll Number',
    Defect_Description: 'Defect Description',
    Points: 'Points',
    Defect: 'Defect',

    Product_Width: 'Product Width',
    Full_Width: 'Full Width',
    Cuttable_Width: 'Cuttable Width',

    DATA_MEASUREMENT_FIELD_TEST: 'DATA MEASUREMENT / FIELD TEST',
    Test_Item: 'Test Item',
    Date_Records: 'Date Records',
    Conclusion: 'Conclusion',
    Test: 'Test',
    Remarks: 'Remarks',

    DEFECTIVES_LIST: 'DEFECTIVES LIST: Four Point System',

    Brief_Findings: 'Brief Findings',
    A_Bulk_Summary: 'A.  Bulk Summary',
    B_Packing_Information: 'B.  Packing Information',
    C_Workmanship: 'C.  Workmanship',
    D_Product_Width: 'D. Product Width',
    E_Data_measurement_Field_test: 'E.  Data measurement/ Field test',
    F_Defects_List: 'F.  Defects List: Four Point System',
    Conform: 'Conform',
    Not_Conform: 'Not Conform',
    Pending: 'Pending',
  },

  //验厂报告详情
  factoryReport: {
    General_Information: 'General Information',
    Client_Name: 'Client Name',
    Factory_Name: 'Factory Name',
    Business_License_Address: ' Business License Address',
    Actual_Factory_Address: 'Actual Factory Address',
    Conform: 'Conform',
    Not_Conform: 'Not Conform',
    Factory_Legal_Person: 'Factory  Legal Person',
    Factory_Ownership: 'Factory Ownership',
    Factory_Established_At: ' Factory Established At',
    Business_License_valid_till: 'Business License valid till',
    Business_License_Number: 'Business License Number',
    Registered_Capital: 'Registered Capital',
    Main_Product: 'Main Product',
    Website: 'Website',
    Main_Market: ' Main Market',
    Service_data: 'Service data',
    Annual_Audit: 'Annual Audit',
    Annual_Output: 'Annual Output (RMB)',

    Business_License: 'Business License',
    Factory_Property_Ownership_Certificate:
      'Factory Property Ownership Certificate',
    Tenancy_Agreements: 'Tenancy Agreements',
    ID_Card_Of_The_Legal_Person: 'ID Card Of The Legal Person',
    Company_Awards: 'Company Awards',

    Production_Capability: 'Production Capability',
    Product_Catalogue: 'Product Catalogue',
    Product_Quality_Certificate: 'Product Quality Certificate',
    Products_Awards: 'Products Awards',
    Brochure: 'Brochure',
    Client_Product_reference: 'Client’s Product reference',

    Workshop_Plant_Overview: 'Workshop & Plant Overview',
    Factory_Area: 'Factory Area (㎡)',
    Office_Area: 'Office Area (㎡)',
    Workshop_Area: 'Workshop  Area (㎡)',
    Raw_Material_Warehouse_Area: 'Raw Material Warehouse  Area (㎡)',
    Products_Warehouse_Aera: 'Products Warehouse Aera (㎡)',
    Showroom_Area: 'Showroom Area (㎡)',
    Factory_Environment: 'Factory Environment',
    Clean: 'Clean',
    Dirty: 'Dirty',
    remarks: ' remarks',
    Gate: 'Gate',
    Office: 'Office',
    Showroom: 'Showroom',
    Workshop: 'Workshop',
    Raw_Material_Warehouse: 'Raw Material Warehouse',
    FG_Warehouse: 'FG Warehouse',
    Staff_Dormitory: 'Staff Dormitory',
    Canteen: 'Canteen',
    Factory_Infirmary: 'Factory Infirmary',

    Equipments_Information: 'Equipments Information',
    Equipment_Name: 'Equipment Name',
    Model_Nr: 'Model Nr',
    Quantity: 'Quantity',
    Maintenance_Records: 'Maintenance Records',
    Yes: 'Yes',
    NO: 'NO',
    Equipment_List: 'Equipment List',
    Equipment: 'Equipment',

    Production_Manufacturing_Process: 'Production & Manufacturing Process',
    Production_Line: 'Production Line',
    Automatization: 'Automatization',
    Full_automatic: 'Full-automatic',
    Semi_automatic: 'Semi-automatic',
    Production_Line_Quantity: 'Production Line Quantity',
    Staff_Quantity: 'Staff Quantity',
    Yearly_Output: 'Yearly Output ',

    Human_Resourse_Records: 'Human Resourse Records',
    Staff_Registered: 'Staff Registered',
    Staff_on_Duty: 'Staff on Duty',
    Management: 'Management',
    Product_Department: 'Product Department',
    Logitics_Division: 'Logitics Division',
    Busiess_Department: 'Busiess Department',
    Research_and_Development_Department: 'Research and Development Department',
    Admiistrative_Department: 'Admiistrative Department',
    Others: 'Others',
    Staff_List: 'Staff  List',
    Staff_Archives: 'Staff Archives',
    Recent_Months_Attendance: 'Recent 3 Months’ Attendance',
    Recent_Months_Salary: 'Recent 3 Months’ Salary',
    All: 'All',

    Operation_Records: 'Operation Records',
    Tax_Bill_Recent_Month: 'Tax Bill ( Recent 3 Month )',
    Rent_Records: 'Rent Records (Recent 3 Months)',
    Utility_bills: 'Utility bills (Recent 3 Months )',
    Material_Input_Invoices: 'Material Input Invoices (Recent 6 Months)',
    Output_Invoices: 'Output Invoices  (Recent 6 Months)',
    Material_Warehouse_Records: 'Material Warehouse Records',
    Product_Warehouse_Records: 'Product Warehouse Records',
    Bill_of_Material: 'Bill of Material',
    Production_Plan: 'Production Plan',
    Production_Summary: 'Production Summary',
    Inspection_Records: 'Inspection Records',
    The_factory_failed: 'The factory failed to provide the following document ',

    Conclusion: 'Conclusion',
    Advantage: 'Advantage',
    Disadvantage: 'Disadvantage',
  },
  myHome: {
    //新增
    Report_To_Be_Done: 'Report To Be Done',
    Order_To_Be_Done: 'Order To Be Done',
    Chinses_Package_Balance: 'Chinses Package',
    English_Package_Balance: 'English Package',
    Available_Coupons: 'Available coupons',
    Buy_Package: 'Buy Package',
    Zhang: 'PCS',
    Balance_Unit: 'MD',
    now: 'immediately',
    order: 'Order',
    Product: 'Product',
    Factory: 'Factory',
    Supervision: 'Supervision',
    Fabric: 'Fabric',
    Username: 'Username',
    More: 'More',
    Pay: 'Pay',
    Cancel: 'Cancel',
    Edit: 'Edit',
    Delete: 'Delete',
    Recover: 'Recover',
    View: 'View',
    RECOVER_Order: 'Really want to RECOVER the order?',

    Order_List: 'Order List',
    Account: 'Account',
    Report_Overview: 'Report Overview',
    Account_Balance: 'Account Balance',
    Plan_Balance: 'Package Balance',
    CN_Plan: 'CN Plan',
    EN_Plan: 'EN Plan',
    Coupons: 'Coupons',
    DELETE_Order: 'Really want to DELETE the order?',
    CANCEL_order: 'Really want to CANCEL the order?',
    Download: 'Download',
  },
  Category: {
    Groceries: 'Groceries ',
    Electronics: 'Electronics & Electrical Equipment',
    Fabric: 'Fabric & Textiles',
    Garment: 'Garment & Bags',
  },
  BarOther: {
    home: 'Home',
    service: 'Service',
    quality: 'Quality Control',
    rkkw9t: 'Container Loading',
    oww1lo: 'Vendor Assessment',
    vwiq99: 'New Product Development',
    fuaoau: 'User Guide',
    q618ep: 'Contact',
    iqp9rr: 'Get Started',
    b2xprb: 'CN',
  },
  FooterOther: {
    zs3eck: 'Get service on the phone',
    ktb2ur: 'Minder Inspection',
    '6yyjjc': 'Works with Minder, Minder Works',
    re5sad: 'Minderworks  All Rights Reserved',
    usnxbi: 'Contact us',
  },
  main: {
    '1dt1j2': 'Keep Your Product Qualified',
    quailty:
      ' When it                                                             comes to quality, we think                                                             of every single                                                             piece',
    pczd9p: 'Start Now',
    '7rbwz7':
      ' Minder Inspection is a third-party inspection platform. Minder provide                             quality control services                             such as product inspection, vendor auditing, Loading supervision etc. which help customers                             optimizing quality system.&nbsp; Our smart monitoring system brings highly efficient quality                             tracking experiences.',
    d5ccl3: 'What we offer',
    hb3x95:
      ' Minder offers you a New way to tracking quality control process, By providing excellent                             inspection services, we are aiming to get your trade done much more easier than you ever                             imagined before.',
    ss10g8: 'Product Quality Control',
    jspb3m: 'More',
    u44avv: 'Vendor Assessment',
    cpnavt: 'Container Loading',
    xf74pb: 'Product Development',
    qlu4ej: 'What we can bring you',
    '1bfizf': 'Quality Control Team',
    me37mm:
      'Minder Inspectors are with professional inspection capability, the experienced team will be able to provide excellent quality control services.',
    cb2q1j: 'Anytime,Anywhere',
    var86x:
      'Minder’s service covers most region of China. There’s no worry about the distance and time. You are able to access our on-line system and view report',
    nwz8j7: 'Cost efficient',
    rto9zc:
      'Travel to the factory site may cost you more on flights and accommodations. With our service, there’s no extra cost to worry about.',
    wkmsf4: 'Data driven Report',
    '25f6ak':
      'Our report is  based on real data collected from the on-site check which Allows you to get more precise data during the measurement and on-site tests',
    p4586r: "Let's get start",
    jtdq0u: 'Get Started',
    f3oiph:
      'Simply log into our Minder online booking system and input the basic information  to submit the booking',
    v3ojm4: 'Want to check our sample report?',
    b1u9xm: 'Get a Sample report',
    okn6an: 'Enter your email here *',
    u5asdi: 'Sign Up',
  },
  quailty: {
    '0mal0f': ' Quality control service',
    po356y: 'During Production Inspection',
    '26c0pu':
      'During Production Inspection is performed when 30%- 50% goods are finished and                                             packed. This inspection validates the initial production process has been                                             maintained and that goods being produced continue to meet quality requirements.                                             In the case of new raw materials, new operators, production lines or                                             specification changes, this service can assess if requirements are being met                                             during production.',
    '5k1ybr': 'Pre-Shipment Inspection',
    ttza9v:
      "Pre-shipment Inspection (Final Inspection) is a most effective way that confirms                                             the whole shipment's quality level. It normally requires the production to be                                             100% complete and at least 80% of goods to be packed into cartons. Quality                                             engineers will do the random sampling and inspect strictly according to the AQL                                             standards.",
    okc6nf: 'Multiple Categories',
    wssl3q:
      ' Tool, Toy, Furniture, Hardware, Decoration, Personal care, Outdoor equipment etc.',
    kb9sl6: 'Groceries',
    rgkx6g: 'fabric, textile and raw material, home furnishing etc.',
    d94vs5: 'Fabric & Textiles',
    qtay9t: 'Garment, Accessory, Bag, Luggage, Shoe etc.',
    wdw9wg: 'Garment & Bags',
    dq5hgi:
      'Home electrical equipment, Electronics, Lights, Electronic accessory etc.',
    fndilq: 'Electronics & Electrical Equipment',
    yovmva: ' Amazing Price',
    h4zdms: 'Get Plan',
  },
  container: {
    '0mal0f': ' Quality control service',
    po356y: 'During Production Inspection',
    '26c0pu':
      'During Production Inspection is performed when 30%- 50% goods are finished and                                             packed. This inspection validates the initial production process has been                                             maintained and that goods being produced continue to meet quality requirements.                                             In the case of new raw materials, new operators, production lines or                                             specification changes, this service can assess if requirements are being met                                             during production.',
    '5k1ybr': 'Pre-Shipment Inspection',
    ttza9v:
      "Pre-shipment Inspection (Final Inspection) is a most effective way that confirms                                             the whole shipment's quality level. It normally requires the production to be                                             100% complete and at least 80% of goods to be packed into cartons. Quality                                             engineers will do the random sampling and inspect strictly according to the AQL                                             standards.",
    okc6nf: 'Multiple Categories',
    wssl3q:
      ' Tool, Toy, Furniture, Hardware, Decoration, Personal care, Outdoor equipment etc.',
    kb9sl6: 'Groceries',
    rgkx6g: 'fabric, textile and raw material, home furnishing etc.',
    d94vs5: 'Fabric & Textiles',
    qtay9t: 'Garment, Accessory, Bag, Luggage, Shoe etc.',
    wdw9wg: 'Garment & Bags',
    dq5hgi:
      'Home electrical equipment, Electronics, Lights, Electronic accessory etc.',
    fndilq: 'Electronics & Electrical Equipment',
    yovmva: ' Amazing Price',
    h4zdms: 'Get Plan',
    r3687u: ' Loading Supervision',
    ociaza:
      'Loading Supervision provides witness to the loading process, to make sure the correct                                 quantity and good condition cartons are loaded into good condition containers.',
    qmk06r:
      'To avoid the potential or accidental damage to the goods, our Engineer will guide the factory or                     forwarder to conduct a more safe and effecient loading.',
    uhc0i8: ' Key Value you will get',
    uiovue:
      'Ensure your products are transported in the appropriate conditions',
    ykb6cu:
      'Verify the right goods are loaded into the containers (no substitution).',
    t76xgv:
      'Confirm your products are packaged and shipped as per conditions stated on the sales contract.',
  },
  vendor: {
    '2ikbjo': 'Vendor Assessment',
    c4qsgh: 'Want to know more about your potential supplier?',
    ja3s8r:
      'Optimizing your vendor manangement, we offer you a better solution!',
    xuz603: '清晰识别供应商',
    zxy9bc: 'Real data suppot the right decision',
    yewaw8:
      'You are able to access to your potential vendor in a much more efficient way. We present detailed data and files of the vendor which will be quite crucial to your decision.',
    qnzcvs: 'Get a close look of your vendor',
    v4f2fg:
      'Industries varies from each other. Expertise is required in dealing with certain business. We analyze and assess your vendor in a particular way.',
    '2lrzjb': 'We know what you care most',
    '4ez0fi':
      'With our flexible order system, your special requirements will be well noticed. You are able to grab the details that you care most.',
    '3a65tn': 'Key Features',
  },
  product: {
    asifsf: 'New Product Development',
    '5e2vvj':
      'Normally it takes much energy and cost on communications between factory team and the R&D                                 team during the new product development. we are here to help!',
    '4ebm8s': 'Keep the Launch schedule on track',
    gsfl38:
      'When you start a new project, you might need to make several mockups or prototypes. normally the                             reviews will get back and forth and it takes a long time to deliver samples. In many cases, it                             will probably create launch delay.',
    nf0053:
      ' We will visiting the factory and help geting samples check and give reviews based on                             communication. and our team will put your projects on track till the product are ready to be                             produced from Prototype',
    csgmvo: ' Developing',
    ie98hv: 'Process',
    a9sghc: 'Design & Prototype',
    zztqn9:
      ' Prototype needs carefully checked and it needs several rounds of feedback',
    kbjhoe: ' Product Testing',
    jilwi4:
      'The prototypes requires a series of testing such as functional testing, Material lab testing etc.​  ',
    urjj9c: 'Tooling',
    '43jimm':
      'When it comes to final confirmation sample, some components required special mold, we need to control the tooling condition ',
    hdanvk: 'PP sample review',
    '5mucjv':
      ' In many cases, Pre-production sample needs to be carefully check for this is the last step before step into mass production ',
  },
  guide: {
    '6utg29': 'User Guide',
    '3proyr': 'Just a few steps to connect Minder Inspection system',
    r9gfva: 'Quick connect',
  },
  FQA: {
    '1ny4sh': 'Facts &',
    '0bdyn9': 'Questions',
    juuubr: 'What kind of service can I get from Minder ? ',
    j371ii: ' How to caculate the price?',
    m63h4i: ' How can I proceed the payment ?',
    '6a7k58': 'What is the key advantages can I expect here ?',
    cida7w: 'Can I cancel the Order in specific case ?',
    wptwf3:
      'Minder Provides services helping oversea buyers better control the goods import. Services like Quality inspection, Loading control, Vendor Audit, Product development. These are the key stages among the whole import & export  process. And they deserves a better control.',
    xzgjmq:
      'Minder services is caculated in M/D. The price will be different for different catagories. Our Account Manager will contact you to quote you the Price in M/D after the order is created in our system. You will be notified in Email the exact price for specific order',
    '3lr87o': 'You can Pay either in RMB or USD Payment methods: ',
    '3lr8733':
      '  1. Minder Plan 2. AliPay 3. WeChat Pay 4. PayPal 5. Bank Wire Transfer',

    grrsci:
      '1. Minder focused on the quality control system. we studied a lot of customers including trade agents and importers. We know what you care about your goods.',
    grrsci1:
      ' 2. With our integrated data collect system, our quality engineers get you the most important figures and these data will be shown clearly in our report which makes the report easy to read. ',
    grrsci2:
      ' 3. Minder provides high competitive price and you save more with our Plan.',
    grrsci3: ' ',

    rni8xf:
      'Yes, you can. If by any chance you input the incorrected order information, you can cancel the order. (Before the Due Date)',
    '68lado':
      'Yes, you can. If by any chance you input the incorrected order information, you can cancel the order. (Before the Due Date)',
  },
  contact: {
    '44bpko': "LET'S GET CNNECTED !",
    tip01: 'Please input a valid email address',
    '8b7im3': 'Name',
    '6zh5n2': 'Email',
    ujdprn: 'Message',
    aes7hy: 'Submit',
  },
};
